module.exports = __webpack_public_path__ + "static/media/cloud4.cb5f0156.png";